import { LANGUAGE_FIELDS } from '@client/feature/activeSubstance/config/filterConfigs';

/**
 * Configuration for treatment multichoix search steps
 * 6 steps with multi-select capabilities
 */
export const MULTICHOIX_SEARCH_STEPS = [
  {
    key: 1,
    title: 'multichoix.steps.culture.title',
    placeholder: 'multichoix.steps.culture.placeholder',
    description: 'multichoix.steps.culture.description',
    field: 'treatment_cultures.culture',
    document: 'TreatmentDocument',
    label_field: 'french_name',
    value_field: 'id',
    languageConfig: LANGUAGE_FIELDS.cultures,
    autoProgress: false,
    required: true,
    multiSelect: true,
    componentType: 'cultureTree',
  },
  {
    key: 2,
    title: 'multichoix.steps.cultural_practice.title',
    placeholder: 'multichoix.steps.cultural_practice.placeholder',
    description: 'multichoix.steps.cultural_practice.description',
    field: 'treatment_cultures.cultural_practices',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: false,
    required: true,
    multiSelect: true,
    componentType: 'checkboxTree',
  },
  {
    key: 3,
    title: 'multichoix.steps.treatment_type.title',
    placeholder: 'multichoix.steps.treatment_type.placeholder',
    description: 'multichoix.steps.treatment_type.description',
    field: 'treatment_type',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: false,
    required: true,
    multiSelect: false,
    componentType: 'dropdown',
  },
  {
    key: 4,
    title: 'multichoix.steps.enemies.title',
    placeholder: 'multichoix.steps.enemies.placeholder',
    description: 'multichoix.steps.enemies.description',
    field: 'treatment_enemies.enemy',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'french_name',
    languageConfig: LANGUAGE_FIELDS.enemies,
    autoProgress: false,
    required: true,
    multiSelect: true,
    componentType: 'enemiesComplex',
    subcategories: [
      { key: 'pest', label: 'multichoix.steps.enemies.pests', enemyType: 'pest' },
      { key: 'disease', label: 'multichoix.steps.enemies.diseases', enemyType: 'disease' },
      { key: 'weeds', label: 'multichoix.steps.enemies.weeds', enemyType: 'weeds' },
    ],
  },
  {
    key: 5,
    title: 'multichoix.steps.intervention_period.title',
    placeholder: 'multichoix.steps.intervention_period.placeholder',
    description: 'multichoix.steps.intervention_period.description',
    field: 'intervention_period',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'display_name',
    autoProgress: false,
    multiSelect: true,
    componentType: 'checkboxTree',
    required: true,
  },
  {
    key: 6,
    title: 'multichoix.steps.application_type.title',
    placeholder: 'multichoix.steps.application_type.placeholder',
    description: 'multichoix.steps.application_type.description',
    field: 'application_type',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: false,
    required: true,
    multiSelect: true,
    componentType: 'checkboxTree',
  },
];

export const MULTICHOIX_STEP_STATUS = {
  COMPLETED: 'completed',
  ACTIVE: 'active',
  AVAILABLE: 'available',
  DISABLED: 'disabled',
};

export const MULTICHOIX_MIN_STEPS_FOR_SEARCH = 6;

export const ENEMY_TYPES = {
  PEST: 'pest',
  DISEASE: 'disease',
  WEEDS: 'weeds',
};

export const WEED_FILTER_OPTIONS = [
  { key: 'annual_grasses', label: 'multichoix.steps.enemies.weeds.annual_grasses' },
  { key: 'broad_leaf_annual', label: 'multichoix.steps.enemies.weeds.broad_leaf_annual' },
  { key: 'perennial_grasses', label: 'multichoix.steps.enemies.weeds.perennial_grasses' },
  { key: 'broad_leaf_perennial', label: 'multichoix.steps.enemies.weeds.broad_leaf_perennial' },
  { key: 'other', label: 'multichoix.steps.enemies.weeds.other' },
];
